__turbopack_context__.v({
  "personal-info-form": "q0er8a_personal-info-form",
  "personal-info-form__content": "q0er8a_personal-info-form__content",
  "personal-info-form__content--reduce-spacing": "q0er8a_personal-info-form__content--reduce-spacing",
  "personal-info-form__fieldset": "q0er8a_personal-info-form__fieldset",
  "personal-info-form__footer": "q0er8a_personal-info-form__footer",
  "personal-info-form__heading": "q0er8a_personal-info-form__heading",
  "personal-info-form__legend": "q0er8a_personal-info-form__legend",
  "personal-info-form__separator": "q0er8a_personal-info-form__separator",
  "personal-info-form__sub-heading": "q0er8a_personal-info-form__sub-heading",
});
